export const getNewsList = async function (param) {
    const requestURL = "/news/web/list";
    const requestParam = param;

    const response = await o2.util.Http.requestData(requestURL, requestParam, {parameterType: "json"});

    return response;
};

export const getNews = async function (newsId) {
    const requestURL = `/news/${newsId}`;
    const requestParam = {};

    const response = await o2.util.Http.requestData(requestURL, requestParam, {method: "GET"});

    return response;
};